import { RouteObject } from 'react-router-dom';

import { Vehicles } from '@/pages/Fleet';
import { NewVehicle, ViewVehicle, EditVehicle } from '../pages';

export const VehiclesRoutes: RouteObject[] = [
  {
    path: 'vehicles',
    element: <Vehicles />,
  },
  {
    path: 'vehicles/profile/:id',
    element: <ViewVehicle />,
  },
  {
    path: 'vehicles/profile/:id/edit',
    element: <EditVehicle />,
  },
  {
    path: 'vehicles/new',
    element: <NewVehicle />,
  },
];
